<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AssetPreviewPage from '@/views/apps/assets/preview/AssetPreviewPage.vue'
import { useAssetStore } from '@/@vxapp/Assets/useAssetStore'
import { useEntityPageTitle } from '@/composables/useEntityPageTitle'

definePage({ meta: { ...PageMeta.Assets.preview.meta, pageTitle: 'Asset' } })

const route = useRoute()

interface AssetRecord {
  assetGUID?: string
  name?: string
  uniqueIdentifier?: string | null
}

const assetsStore = useAssetStore() as unknown as { asset: AssetRecord | null }

const assetGuid = computed(() => {
  const { guid } = route.params as unknown as { guid?: string | string[] }

  return Array.isArray(guid) ? (guid[0] ?? '') : (guid ?? '')
})

useEntityPageTitle<AssetRecord>({
  entityName: 'Asset',
  record: () => assetsStore.asset,
  recordGuid: asset => asset.assetGUID,
  identifier: asset => asset.uniqueIdentifier?.trim() || asset.name,
})

/* ** */
</script>

<template>
  <section>
    <!--
      Horizontal Menu / Navigation
      <VRow>
      <VCol cols="12">
      <HorizontalAssetsMenu/>
      </VCol>
      </VRow>
    -->

    <!-- Page -->
    <VRow>
      <VCol cols="12">
        <AssetPreviewPage
          :key="assetGuid"
          :asset-g-u-i-d="assetGuid"
        />
      </VCol>
    </VRow>
  </section>
</template>
